import { Component, OnDestroy, OnInit, ViewEncapsulation, Renderer2 } from '@angular/core';
import { ApiService, SocketService, ChatService } from 'angular-lib';
import { environment } from '../../../environments/environment';
import { NavigationEnd, Router } from '@angular/router';
import { Subscription } from 'rxjs/Subscription';

@Component({
    selector: 'ez-member',
    template: require('./member.component.html'),
    styles: [require('./member.component.less')],
    encapsulation: ViewEncapsulation.None
})
export class MemberComponent implements OnInit, OnDestroy {
    private routingEvent: Subscription;
    private passwordCheck: boolean = false;

    constructor(
        private socketService: SocketService,
        private router: Router,
        private apiService: ApiService,
        private renderer: Renderer2,
        private chatService: ChatService
    ) {
        let jwt = localStorage.getItem(environment.tokenName);
        socketService.setJWT(jwt);

        this.renderer.removeClass(document.body, 'public');
        this.renderer.addClass(document.body, 'member');

        if (window.navigator.geolocation) {
            window.navigator.geolocation.getCurrentPosition((position) => {
                this.apiService.saveCrossGeolocation(position.coords.latitude, position.coords.longitude)
                    .subscribe();
            });

            setInterval(
                () => {
                    window.navigator.geolocation.getCurrentPosition((position) => {
                        this.apiService.saveCrossGeolocation(position.coords.latitude, position.coords.longitude)
                            .subscribe();
                    });
                }, 3600000
            );
        }
    }

    public ngOnInit() {
        this.routingEvent = this.router.events
            .filter(event => event instanceof NavigationEnd)
            .subscribe(() => {
                if (!this.passwordCheck) {
                    this.apiService.user().subscribe(user => {
                        // if user doesn't have set his password yet
                        if (user.hasGeneratedPassword) {
                            this.router.navigate(['member/account/password']);
                        }
                        this.passwordCheck = true;
                    });
                }

                // if chat bubble is marked as to be reloaded, consume it
                if (this.chatService.isUnreadBubbleMarkedForRefresh()) {
                    this.chatService.refreshUnreadMessageBubbleState();
                }
            });

        this.apiService.miscConfig().subscribe((res) => {
            let locales = res.locales;

            // this is for page reload (page reload doesn't trigger navigationend, probably triggered before listening)
            this.apiService.user().subscribe((user) => {
                // if user doesn't have set his password yet
                if (user.hasGeneratedPassword) {
                    this.router.navigate(['member/account/password']);
                }

                // set user locale
                for (let key in locales) {
                    if (locales.hasOwnProperty(key) && locales[key].id === user.localeId) {
                        localStorage.setItem('locale', locales[key].code);
                    }
                }
            });
        });

        // get user for chat infos
        this.apiService.user().subscribe(user => {
            // initializing chat service
            this.chatService.setChannelId(user.channelId);

            // start listening for chat events
            this.chatService.bypassSocketFilter(true);
        });

        // check if chat unread bubble need to be shown
        this.chatService.refreshUnreadMessageBubbleState();

    }

    public ngOnDestroy() {
        if (this.routingEvent !== null) {
            this.routingEvent.unsubscribe();
        }
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./src/app/components/member/member.component.ts